import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';
import LazyHydrate from 'vue-lazy-hydration';
import { mapState, mapGetters } from 'vuex';
import { ICartSuggestedCoupon } from '~/types/cart';
import type { Offer } from '~/types/catalog';

@Component({
    components: {
        LazyHydrate,
        // rating: require('~/components/common/rating/').default,
        customPicture: require('~/components/common/switching-picture/').default,
        customImage: require('~/components/common/image/').default,
        btn: require('~/components/form/button/').default,
        favoriteBtn: require('~/components/pages/product/favorite-btn').default,
        // materialInfo: require('~/components/catalog/offer-material-info').default,
        propsInfo: require('~/components/catalog/offer-props').default,
        baseInfo: require('~/components/catalog/offer-base').default,
        buyBtn: require('~/components/catalog/offer-buy-btn').default,
        yandexPayBadge: require('~/components/catalog/yandex-pay-badge').default,
        additionalPictures: require('~/components/catalog/offer-additional-pictures').default,
    },
    computed: {...mapGetters(['hasSplit']), ...mapState('coupons', {couponList: 'coupons'})},
})
export default class OfferComponent extends Vue {

    @prop()
    public item: Offer;

    @prop({type: Boolean, default: false})
    public showWithoutPrice: boolean;

    private tracked = false;
    
    public isFavorite: boolean = false;

    public hasSplit: boolean;

    public couponList: ICartSuggestedCoupon[];

    get badges() {
        return new Set(this.item.badges);
    }

    public trackLink() {
        const counter = (window as any).yaCounter;

        if (!counter || this.tracked) {
            return;
        }

        this.tracked = true;

        if (this.badges.has('new')) {
            if (!!this.item.price.discount) {
                counter.reachGoal("CARDNEWSALE");
            } else {
                counter.reachGoal("CARDNEW");
            }
        } else {
            if (!!this.item.price.discount) {
                if (this.item.limited) {
                    counter.reachGoal("SALEOGR");
                } else {
                    counter.reachGoal("SALE");
                }
            } else {
                counter.reachGoal("CARD");
            }
        }
    }

    get suggestedCoupon() {
        if (!this.item.price.discount) {
            return 0;
        }

        const options: number[] = [];

        this.couponList.forEach((el) => {

            const availableOptions = el.variants.filter(
                (e) => (e.suggestType & 4) && !(e.discountTypes && !(e.discountTypes & this.item.price.discount!.type)));

            if (!availableOptions.length) {
                return;
            }

            options.push(availableOptions[0].value);
        });

        if (!options.length) {
            return 0;
        }

        return Math.max(...options);
    }

}
